import React from 'react';
import ProfileDetails from "./component/ProfileDetails";
function ProfileDetailsPage() {
    return <ProfileDetails/>;
}
export default ProfileDetailsPage;